import "./ParallaxGallery.scss";
import { define } from "@shared/Lib/registry";
import type { Component } from "@shared/Lib/types";

export class ParallaxGallery implements Component {
  readonly el: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
    this.init();
  }

  private init(): void {}

  destroy(): void {}
}

define("ParallaxGallery", (el) => new ParallaxGallery(el));
